module.exports = __webpack_public_path__ + "static/media/google.b3d0f808.png";